//See receipt button
import confirmation from "../../assets/page-shots/confirmation.svg";

function ConfirmationPage() {
  return (
    <div className="page-screenshot">
      <img src={confirmation} alt="" />
    </div>
  );
}

export default ConfirmationPage;
